module.exports = __webpack_public_path__ + "img/level1_idle.a4d99bde.png";